import { Modifiers } from '../../helpers/getModifiers';
import { colorSchemes } from '../../themes';
export var acceptableProps = Modifiers.allAcceptableArrayProps;
export var avatarProps = function (theme) { return ({
    fontFamily: theme.brand.fontFamily,
    color: theme.neutrals.gray8,
    bgColor: theme.neutrals.pureWhite,
    height: 160,
    width: 160,
    bRadius: '50%',
    bWidth: theme.borderWidth.thin,
    bColor: theme.neutrals.gray4,
    bStyle: 'dashed',
    fontSize: theme.fontSize.xxxs,
    fontStyle: 'normal',
    lineHeight: theme.brand.lineHeight.lg,
    fontWeight: theme.brand.fontWeight.bold,
    iconColor: theme.neutrals.gray6,
}); };
export var optionsProps = function (props, theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var optionsProps = props.optionsProps, _hover = props._hover;
    var edit = (_a = optionsProps === null || optionsProps === void 0 ? void 0 : optionsProps.edit) !== null && _a !== void 0 ? _a : {};
    var hoverEdit = (_c = (_b = _hover === null || _hover === void 0 ? void 0 : _hover.optionsProps) === null || _b === void 0 ? void 0 : _b.edit) !== null && _c !== void 0 ? _c : {};
    var remove = (_d = optionsProps === null || optionsProps === void 0 ? void 0 : optionsProps.remove) !== null && _d !== void 0 ? _d : {};
    var hoverRemove = (_f = (_e = _hover === null || _hover === void 0 ? void 0 : _hover.optionsProps) === null || _e === void 0 ? void 0 : _e.remove) !== null && _f !== void 0 ? _f : {};
    return {
        edit: {
            icon: edit === null || edit === void 0 ? void 0 : edit.icon,
            iconColor: (edit === null || edit === void 0 ? void 0 : edit.iconColor) || colorSchemes.blue.pure,
            bgColor: (edit === null || edit === void 0 ? void 0 : edit.bgColor) || theme.neutrals.pureWhite,
            width: (edit === null || edit === void 0 ? void 0 : edit.width) || theme.fixedHeight.md,
            height: (edit === null || edit === void 0 ? void 0 : edit.height) || theme.fixedHeight.md,
            bRadius: (edit === null || edit === void 0 ? void 0 : edit.bRadius) || '50%',
            _hover: {
                iconColor: (hoverEdit === null || hoverEdit === void 0 ? void 0 : hoverEdit.iconColor) ||
                    ((_g = optionsProps === null || optionsProps === void 0 ? void 0 : optionsProps.edit) === null || _g === void 0 ? void 0 : _g.iconColor) ||
                    colorSchemes.blue.pure,
                bgColor: (hoverEdit === null || hoverEdit === void 0 ? void 0 : hoverEdit.bgColor) ||
                    ((_h = optionsProps === null || optionsProps === void 0 ? void 0 : optionsProps.edit) === null || _h === void 0 ? void 0 : _h.bgColor) ||
                    theme.neutrals.pureWhite,
                width: (hoverEdit === null || hoverEdit === void 0 ? void 0 : hoverEdit.width) || ((_j = optionsProps === null || optionsProps === void 0 ? void 0 : optionsProps.edit) === null || _j === void 0 ? void 0 : _j.width) || theme.fixedHeight.md,
                height: (hoverEdit === null || hoverEdit === void 0 ? void 0 : hoverEdit.height) ||
                    ((_k = optionsProps === null || optionsProps === void 0 ? void 0 : optionsProps.edit) === null || _k === void 0 ? void 0 : _k.height) ||
                    theme.fixedHeight.md,
                bRadius: (hoverEdit === null || hoverEdit === void 0 ? void 0 : hoverEdit.bRadius) || ((_l = optionsProps === null || optionsProps === void 0 ? void 0 : optionsProps.edit) === null || _l === void 0 ? void 0 : _l.bRadius) || '50%',
            },
        },
        remove: {
            icon: remove === null || remove === void 0 ? void 0 : remove.icon,
            iconColor: (remove === null || remove === void 0 ? void 0 : remove.iconColor) || theme.brand.color.negative.pure,
            bgColor: (remove === null || remove === void 0 ? void 0 : remove.bgColor) || theme.neutrals.pureWhite,
            width: (remove === null || remove === void 0 ? void 0 : remove.width) || theme.fixedHeight.md,
            height: (remove === null || remove === void 0 ? void 0 : remove.height) || theme.fixedHeight.md,
            bRadius: (remove === null || remove === void 0 ? void 0 : remove.bRadius) || '50%',
            _hover: {
                iconColor: (hoverRemove === null || hoverRemove === void 0 ? void 0 : hoverRemove.iconColor) ||
                    ((_m = optionsProps === null || optionsProps === void 0 ? void 0 : optionsProps.remove) === null || _m === void 0 ? void 0 : _m.iconColor) ||
                    theme.brand.color.negative.pure,
                bgColor: (hoverRemove === null || hoverRemove === void 0 ? void 0 : hoverRemove.bgColor) ||
                    ((_o = optionsProps === null || optionsProps === void 0 ? void 0 : optionsProps.remove) === null || _o === void 0 ? void 0 : _o.bgColor) ||
                    theme.neutrals.pureWhite,
                width: (hoverRemove === null || hoverRemove === void 0 ? void 0 : hoverRemove.width) ||
                    ((_p = optionsProps === null || optionsProps === void 0 ? void 0 : optionsProps.remove) === null || _p === void 0 ? void 0 : _p.width) ||
                    theme.fixedHeight.md,
                height: (hoverRemove === null || hoverRemove === void 0 ? void 0 : hoverRemove.height) ||
                    ((_q = optionsProps === null || optionsProps === void 0 ? void 0 : optionsProps.remove) === null || _q === void 0 ? void 0 : _q.height) ||
                    theme.fixedHeight.md,
                bRadius: (hoverRemove === null || hoverRemove === void 0 ? void 0 : hoverRemove.bRadius) || ((_r = optionsProps === null || optionsProps === void 0 ? void 0 : optionsProps.remove) === null || _r === void 0 ? void 0 : _r.bRadius) || '50%',
            },
        },
    };
};
